<template>
    <div>
        <inner-page-banner-component></inner-page-banner-component>

        <main class="vps-hosting ptb100">
            <!-- Section Title -->
            <div class="section-title">
                <h2>VPS Hosting Plans</h2>
                <p>
                    Make your cloud computing project take off. It has never been easier to have your own server running
                    in the cloud
                </p>
            </div>

            <section class="pricing-offers">
                <div class="row">
                    <!-- Start of Featured Pricing Table -->
                    <div itemscope="" itemtype="http://schema.org/Product" class="col-md-4 pricing-plan-featured">
                        <div class="price-box">
                            <h5><strong><span itemprop="name">Yeti</span></strong></h5>
                            <span itemprop="offers" itemscope="" itemtype="http://schema.org/AggregateOffer">
                     <span style="display: none" itemprop="priceCurrency">ZWL</span>
                     <h2>
                        <sup>$</sup>
                        <span itemprop="price">52.5</span>
                     </h2>
                     <span style="display: none" itemprop="lowPrice">52.5</span>
                  </span>
                            <div itemprop="description" class="price-features">
                                <p>15GB SSD Storage</p>
                                <p>1 CPU vCORE</p>
                                <p>512MB RAM</p>
                                <p>1TB Bandwidth @ 1Gbs</p>
                                <p>1 Dedicated IP</p>
                            </div>
                            <a href="#"
                               class="btn btn-blue btn-effect">signup now</a>
                        </div>
                    </div>
                    <!-- End of Featured Pricing Table -->
                    <!-- Start of Featured Pricing Table -->
                    <div class="col-md-4 pricing-plan">
                        <div itemscope="" itemtype="http://schema.org/Product" class="price-box">
                            <h5><strong><span itemprop="name">Polar Bear</span></strong></h5>
                            <span itemprop="offers" itemscope="" itemtype="http://schema.org/AggregateOffer">
                     <span style="display: none" itemprop="priceCurrency">ZWL</span>
                     <h2>
                        <sup>$</sup>
                        <span itemprop="price">90</span>
                        <span style="display: none" itemprop="lowPrice">90</span>
                     </h2>
                  </span>
                            <div itemprop="description" class="price-features">
                                <p>25GB to 50GB SSD Storage</p>
                                <p>1 CPU vCORE</p>
                                <p>1GB RAM</p>
                                <p>1.5TB Bandwidth @ 1Gbs</p>
                                <p>1 Dedicated IP</p>
                                <p>DDoS Protection</p>
                            </div>
                            <a href="#"
                               class="btn btn-blue btn-effect">signup now</a>
                        </div>
                    </div>
                    <!-- End of Featured Pricing Table -->
                    <!-- Start of Featured Pricing Table -->
                    <div class="col-md-4 pricing-plan">
                        <div itemscope="" itemtype="http://schema.org/Product" class="price-box">
                            <h5><strong><span itemprop="name">Arctic Fox</span></strong></h5>
                            <span itemprop="offers" itemscope="" itemtype="http://schema.org/AggregateOffer">
                     <span style="display: none" itemprop="priceCurrency">ZWL</span>
                     <h2>
                        <sup>$</sup>
                        <span itemprop="price">350</span>
                        <span style="display: none" itemprop="lowPrice">350</span>
                     </h2>
                  </span>
                            <div itemprop="description" class="price-features">
                                <p>75GB to 100GB Storage</p>
                                <p>2 CPU vCORE</p>
                                <p>1GB RAM</p>
                                <p>4TB Bandwidth @ 1Gbs</p>
                                <p>1 Dedicated IP</p>
                                <p>DDoS Protection</p>
                                <p>Free Windows Server Licence</p>
                            </div>
                            <a href="#"
                               class="btn btn-blue btn-effect">signup now</a>
                        </div>
                    </div>
                    <!-- End of Featured Pricing Table -->
                </div>
            </section>

            <div class="container pt50 faqs">

                <h2 class="fw-600 mb-20 text-center"><b>VPS hosting</b>: Frequently Asked Questions
                (FAQ)</h2>

                <p class="text-content-grey text-center mb-35 subtitle">Find answers to some frequently asked questions
                    about cheap VPS hosting &amp; best virtual private servers.</p>
                <div class="panel-group faq-block" id="accordion" role="tablist" aria-multiselectable="true">
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingZero">
                            <div class="faq-button collapsed" role="button" data-toggle="collapse"
                                 data-parent="#accordion" href="#collapseZero" aria-expanded="true"
                                 aria-controls="collapseZero"><h3 class="text-light-black fw-600">
                                What is VPS? </h3></div>
                        </div>
                        <div id="collapseZero" class="panel-collapse collapse show" role="tabpanel"
                             aria-labelledby="headingZero" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">A VPS stands for “Virtual Private
                                Server.” Let's break it down: as the name suggests, it is a private server, which means,
                                that it will be exclusively yours. Having a VPS service gives you a set amount of
                                resources that you don’t need to share with anyone. It’s kind of like having your very
                                own dedicated or private server, but virtual.</p>
                                <p class="fs-14">In this case, “virtual” means that it is a partition on a physical
                                    server, that is dedicated to you. This virtual server gives you the chance to gain
                                    root access, install your preferred OS and work on your project with unparalleled
                                    freedom.</p>
                                <p class="fs-14">We take care of the back-end business, manage the physical servers,
                                    guarantee speed, uptime, and stability, while you can focus entirely on your
                                    project.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingOne">
                            <div class="faq-button collapsed" role="button" data-toggle="collapse"
                                 data-parent="#accordion" href="#collapseOne" aria-expanded="false"
                                 aria-controls="collapseOne"><h3 class="text-light-black fw-600">
                                What is a Virtual Dedicated Server? How is it different from VPS? </h3></div>
                        </div>
                        <div id="collapseOne" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingOne" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">The two services are similar, but
                                there are some fundamental differences. A VPS server will let you create multiple
                                instances on a single dedicated server. While a VDS or Virtual Dedicated Server will do
                                the same, but take up the entirety of the dedicated server.</p>
                                <p class="fs-14">Virtual Private Server hosting is the perfect price-power option for
                                    large projects as it grants large amounts of dedicated resources and the most
                                    control while being infinitely cheaper than having your own physical dedicated
                                    server.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingTwo">
                            <div class="faq-button collapsed" role="button" data-toggle="collapse"
                                 data-parent="#accordion" href="#collapseTwo" aria-expanded="false"
                                 aria-controls="collapseTwo"><h3 class="text-light-black fw-600">
                                What is cloud computing? </h3></div>
                        </div>
                        <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingTwo" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">Cloud computing is a method of
                                using resources through a network of interlinked remote servers rather than a single,
                                dedicated machine. Cloud computing takes advantage of the high-speed internet and by
                                using sophisticated software, can compute various demanding applications with great
                                efficiency.</p>
                                <p class="fs-14">This kind of computing can manage, process and store data as a regular
                                    server. There are several significant benefits that cloud computing provides: it is
                                    incredibly flexible, seamlessly scalable, resilient and stable and allows smooth
                                    migration.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingThree">
                            <div class="faq-button collapsed" role="button" data-toggle="collapse"
                                 data-parent="#accordion" href="#collapseThree" aria-expanded="false"
                                 aria-controls="collapseThree"><h3 class="text-light-black fw-600">
                                What is the real advantage of using VPS hosting? </h3></div>
                        </div>
                        <div id="collapseThree" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingThree" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">There are a few things that make
                                VPS hosting the best option for specific projects. In short: if you need a lot of
                                resources and unparalleled stability - VPS hosting is for you, but the actual answer is
                                a little bit longer.</p>
                                <p class="fs-14">First of all, VPS hosting gives you dedicated resources. That means you
                                    don’t need to share your CPU power, RAM or disk space. You have an allocated amount
                                    that you control at your will, entirely.</p>
                                <p class="fs-14">The nature of virtual server hosting guarantees stability. Since all
                                    the resources are carefully managed and allocated to the users, you can rest easy
                                    knowing that any periods of high usage will not impact your server stability.</p>
                                <p class="fs-14">Lastly, arguably the most significant advantage of VPS hosting comes at
                                    the highest price. You get root access and unparalleled control of the resources
                                    granted. That means that you can install a wide range of operating systems, work on
                                    resource-heavy projects and do much more, than with shared hosting. But sadly, the
                                    customer support team will only help you with questions relating to VPS hosting
                                    management and other back-end related queries.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingFour">
                            <div class="faq-button collapsed" role="button" data-toggle="collapse"
                                 data-parent="#accordion" href="#collapseFour" aria-expanded="false"
                                 aria-controls="collapseFour"><h3 class="text-light-black fw-600">
                                What are the differences between VPS and Shared Hosting? </h3></div>
                        </div>
                        <div id="collapseFour" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingFour" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">VPS and Shared hosting have some
                                similarities, but they’re fundamentally different kinds of services.</p>
                                <p class="fs-14">
                                    <router-link to="/hosting/shared">Shared hosting packages</router-link>
                                    are aimed for small projects, such as personal blogs and similar sites. Resource
                                    intensive or high-traffic projects might encounter issues while using a shared
                                    hosting service. Shared hosting is incredibly beginner friendly and fully managed,
                                    which means that our customer support team will be able to help out with most issues
                                    that might occur with your project. </p>
                                <p class="fs-14">VPS hosting, on the other hand, provides you with dedicated resources
                                    that you don’t need to share. Every virtual private server hosting plan makes sure
                                    that you get the highest control of your resources. Control your CPUs, Burst RAM,
                                    manage root access and use your preferred OS. The downside of VPS hosting is that,
                                    while we cover the back-end and server monitoring, maintaining it 24/7, we can
                                    provide limited help to your project concerning customer support. While all VPS
                                    hosting and control panel questions we will help with, programming, coding and other
                                    queries of similar nature won't be covered.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingFive">
                            <div class="faq-button collapsed" role="button" data-toggle="collapse"
                                 data-parent="#accordion" href="#collapseFive" aria-expanded="false"
                                 aria-controls="collapseFive"><h3 class="text-light-black fw-600">
                                What projects does VPS hosting suit best? </h3></div>
                        </div>
                        <div id="collapseFive" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingFive" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">Virtual server hosting is aimed
                                towards more tech-savvy users. If you need a small website, you’re probably better off
                                with shared hosting or premium hosting.</p>
                                <p class="fs-14">But if you require a lot of computing power and maximum control VPS
                                    hosting is only second to a dedicated server. Intensive websites, web apps, online
                                    game servers, databases and other kinds of complex projects are perfect for a VPS
                                    hosting service. VPS hosting provides more control than any other service, as you
                                    can install your preferred OS and take advantage of root access.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingSix">
                            <div class="faq-button collapsed" role="button" data-toggle="collapse"
                                 data-parent="#accordion" href="#collapseSix" aria-expanded="false"
                                 aria-controls="collapseSix"><h3 class="text-light-black fw-600">
                                Does VPS require a lot of technical knowledge? </h3></div>
                        </div>
                        <div id="collapseSix" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingSix" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">VPS hosting services are
                                semi-managed, which means that with some issues you’ll have to consult the knowledge
                                base and tutorials, rather than receive help from our customer support.</p>
                                <p class="fs-14">VPS hosting grants unmatched control of your experience. To use all the
                                    power provided effectively, you will have to have technical knowledge.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingSeven">
                            <div class="faq-button collapsed" role="button" data-toggle="collapse"
                                 data-parent="#accordion" href="#collapseSeven" aria-expanded="false"
                                 aria-controls="collapseSeven"><h3 class="text-light-black fw-600">
                                Will I get any kind of assistance while using VPS? </h3></div>
                        </div>
                        <div id="collapseSeven" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingSeven" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">VPS hosting services are
                                semi-managed. Our customer support team will do their best to b help with every single
                                query that might arise and all questions relating to the back-end or control panel will
                                be answered, but project related, front-end questions will not be covered.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingEight">
                            <div class="faq-button collapsed" role="button" data-toggle="collapse"
                                 data-parent="#accordion" href="#collapseEight" aria-expanded="false"
                                 aria-controls="collapseEight"><h3 class="text-light-black fw-600">
                                How to secure a VPS Server? </h3></div>
                        </div>
                        <div id="collapseEight" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingEight" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">When you read about VPS hosting,
                                some questions naturally arise. Let's say, if there are multiple users on the same
                                dedicated server, running virtual private servers, will they be able to access my data?
                                That’s a valid question to raise, but in this case, we can happily inform you that
                                you’re safe. All VPS hosting services are safely partitioned by specific software, which
                                guarantees top-notch protection.</p>
                                <p class="fs-14">In addition all CryoHost servers are protected by Voxility DDoS Mitigation, advanced
                                    DDoS protection and other custom built tools that both monitor and protect our
                                    entire infrastructure.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingNine">
                            <div class="faq-button" role="button" data-toggle="collapse" data-parent="#accordion"
                                 href="#collapseNine" aria-expanded="false" aria-controls="collapseNine"><h3
                                    class="text-light-black fw-600">
                                Do you provide a dedicated IP address for VPS plans? </h3></div>
                        </div>
                        <div id="collapseNine" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingNine">
                            <div class="panel-body text-content-grey"><p class="fs-14">All VPS hosting plans provide the
                                user with a dedicated IP address.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingTen">
                            <div class="faq-button" role="button" data-toggle="collapse" data-parent="#accordion"
                                 href="#collapseTen" aria-expanded="false" aria-controls="collapseTen"><h3
                                    class="text-light-black fw-600">
                                Can I install custom software on my VPS server? </h3></div>
                        </div>
                        <div id="collapseTen" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingTen">
                            <div class="panel-body text-content-grey"><p class="fs-14">Yes, you can! That’s the beauty
                                of a VPS hosting service. It gives unparalleled control over your project! On Hostinger
                                you can pick between dozens of different Linux based operating systems to suit your
                                needs.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingEleven">
                            <div class="faq-button" role="button" data-toggle="collapse" data-parent="#accordion"
                                 href="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven"><h3
                                    class="text-light-black fw-600">
                                When should you move to VPS hosting? </h3></div>
                        </div>
                        <div id="collapseEleven" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingEleven" style="">
                            <div class="panel-body text-content-grey"><p class="fs-14">The best time to turn to VPS
                                hosting is when you have gathered up the technical knowledge that you may need for this
                                endeavor or when your shared hosting account no longer provides enough resources for
                                your project, and you need to go bigger!</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingTwelve">
                            <div class="faq-button" role="button" data-toggle="collapse" data-parent="#accordion"
                                 href="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve"><h3
                                    class="text-light-black fw-600">
                                Can I easily upgrade VPS to a higher plan? </h3></div>
                        </div>
                        <div id="collapseTwelve" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingTwelve">
                            <div class="panel-body text-content-grey"><p class="fs-14">Of course! We have prepared 3
                                different plans that can fit any project. With every growth period, you can nearly
                                seamlessly pick a more powerful plan and upgrade with no downtime at all.</p></div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingThirteen">
                            <div class="faq-button" role="button" data-toggle="collapse" data-parent="#accordion"
                                 href="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen"><h3
                                    class="text-light-black fw-600">
                                Do you provide Windows VPS hosting? </h3></div>
                        </div>
                        <div id="collapseThirteen" class="panel-collapse collapse" role="tabpanel"
                             aria-labelledby="headingThirteen">
                            <div class="panel-body text-content-grey"><p class="fs-14">Yes, we provide Windows VPS
                                hosting. It is provided for the Artic Wolf VPS package</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import InnerPageBannerComponent from "./partials/InnerPageBannerComponent";

    export default {
        name: "VpsHosting",
        metaInfo: {
            meta: [
                {
                    name: "description",
                    content: "Make your cloud computing project take off. It has never been easier to have your own server running in the cloud"
                }
            ]
        },
        data: () => {
            return {
                whmcsRoot: "https://my.cryo.host/",
                products: {
                    'breeze':
                        '1',
                    'chilly_gust':
                        '2',
                    'freezing_winter':
                        '3',
                    'ice_age':
                        '3'
                }
            }
        }
        , components: {
            InnerPageBannerComponent
        }
        , methods: {
            productLink(pid) {
                if (!this.products.hasOwnProperty(pid)) return 'javascript:void(0)';

                return this.whmcsRoot + "cart.php?a=add&pid=".concat(this.products[pid])
            }
        }
    }
</script>

<style lang="scss" scoped>
    main.vps-hosting {
        padding-left: 20px;
        padding-right: 20px;

        .section-title {
            p {
                font-weight: 400;
                margin-top: 30px;
                font-size: 18px;
                line-height: 1.5;
            }
        }
    }
</style>